<template>
  <div v-if="loading.page">
    <a-skeleton />
  </div>
  <a-row :gutter="24" v-else>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <a-card v-if="jns && jns.toLowerCase() == 'penerimaan_kontrak'">
        <div slot="title" v-if="tab !== 'needprocess'">
          <h4 class="margin-remove">Manifest Account Receivable</h4>
          <small>
            {{ datasource.header_1 ? datasource.header_1.ar_no : "-" }}
          </small>
        </div>
        <div slot="title" v-else>
          <h4 class="margin-remove">Manifest Sales Contract</h4>
          <small>
            {{
              datasource.header_1 ? datasource.header_1.no_sales_contract : "-"
            }}
          </small>
        </div>
        <a-popover slot="extra" trigger="click" placement="bottom">
          <span slot="title">Select Action</span>
          <ul class="m-list-wrapper bordered" slot="content">
            <li>
              <a-button
                type="primary"
                icon="printer"
                block
                ghost
                :loading="loading.loadingPrint"
                @click="handlePrint('1')"
                :disabled="status_cetak"
                >Manifest type 1</a-button
              >
            </li>
            <li>
              <a-button
                type="primary"
                icon="printer"
                block
                ghost
                :loading="loading.loadingPrint2"
                @click="handlePrint('2')"
                :disabled="status_cetak"
                >Manifest type 2</a-button
              >
            </li>
            <li v-if="datasource.iskomisi">
              <a-button
                type="primary"
                icon="printer"
                block
                ghost
                :loading="loading.manifestkomisi"
                @click="handlePrintKomisi"
                >Manifest Komisi</a-button
              >
            </li>
            <li
              v-if="
                getAuth.username ==
                (datasource.header_1 ? datasource.header_1.tlc_create : '-')
              "
            >
              <a-button-group>
                <a-button
                  :disabled="status_edit"
                  @click="handleEdit"
                  type="dashed"
                  icon="edit"
                  >Edit</a-button
                >
                <a-button
                  :disabled="status_cancel"
                  @click="handlecanceltrans"
                  type="danger"
                  icon="close-square"
                  :loading="loading.loadingPrint.cancel"
                  >Cancel</a-button
                >
              </a-button-group>
            </li>
          </ul>
          <a-button icon="more" :size="getScreen ? 'small' : 'default'">{{
            getScreen ? "" : "Action"
          }}</a-button>
        </a-popover>
        <ul class="m-list-wrapper bordered">
          <li>
            <span class="m-list-title" for>Created Date</span>
            <span class="m-list-desc">{{
              moment(
                datasource.header_1 ? datasource.header_1.create_dt : null
              ).format(getDefaultDateFormat)
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>user creator</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.tlc_create : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>kode</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.kode : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>contract no</span>
            <span class="m-list-desc">{{
              datasource.header_1
                ? datasource.header_1.no_contract
                  ? datasource.header_1.no_contract
                  : "-"
                : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>sktd PPN no</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.sktd_ppn_no : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>budget operation</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.pimpro : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>periode</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.periode : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>invoice to</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.invoice_to : "-"
            }}</span>
          </li>
          <!-- <li>
            <span class="m-list-title" for>efaktur no</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? (datasource.header_1.efaktur_no ? 
                datasource.header_1.efaktur_no: "-") : '-'
            }}</span>
          </li> -->
          <li>
            <span class="m-list-title" for>description</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.description : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>revision no</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.revisi_no : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Note</span>
            <span class="m-list-desc">{{
              datasource.header_1
                ? datasource.header_1.note !== "undefined"
                  ? datasource.header_1.note
                  : "-"
                : "-"
            }}</span>
          </li>
        </ul>
      </a-card>
      <a-card v-if="jns.toLowerCase() == 'piutang_lain_lain'">
        <div slot="title">
          <h4 class="margin-remove">Manifest Account Receivable</h4>
          <small>{{
            datasource.header_1 ? datasource.header_1.ar_no : "-"
          }}</small>
        </div>
        <a-popover slot="extra" trigger="click" placement="bottom">
          <span slot="title">Select Action</span>
          <ul class="m-list-wrapper bordered" slot="content">
            <li>
              <a-button
                type="primary"
                icon="printer"
                block
                ghost
                :loading="loading.loadingPrint"
                @click="handlePrint"
                :disabled="
                  (jns.toLowerCase() == 'piutang_lain_lain' ? true : false)
                  && status_cancel
                "
                >Manifest</a-button
              >
            </li>
            <li
              v-if="
                getAuth.username ==
                (datasource.header_1 ? datasource.header_1.tlc_create : '-')
              "
            >
              <a-button-group>
                <a-button
                  :disabled="status_edit"
                  @click="handleEdit"
                  type="dashed"
                  icon="edit"
                  >Edit</a-button
                >
                <a-button
                  :disabled="status_cancel"
                  @click="handlecanceltrans"
                  type="danger"
                  icon="close-square"
                  :loading="loading.loadingPrint.cancel"
                  >Cancel</a-button
                >
              </a-button-group>
            </li>
          </ul>
          <a-button icon="more" :size="getScreen ? 'small' : 'default'">{{
            getScreen ? "" : "Action"
          }}</a-button>
        </a-popover>
        <ul class="m-list-wrapper bordered">
          <li>
            <span class="m-list-title" for>Created Date</span>
            <span class="m-list-desc">{{
              moment(
                datasource.header_1 ? datasource.header_1.create_dt : null
              ).format(getDefaultDateFormat)
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>user creator</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.tlc_create : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Project name</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.project_nm : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>value</span>
            <span class="m-list-desc">{{
              formatCurrency(
                datasource.header_1 ? datasource.header_1.currency : "IDR",
                datasource.header_1 ? datasource.header_1.value : 0
              )
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>customer</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.customer : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>contract no</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.no_contract : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>description</span>
            <span class="m-list-desc">{{
              datasource.header_1 ? datasource.header_1.description : "-"
            }}</span>
          </li>
        </ul>
      </a-card>
      <a-card
        v-if="jns.toLowerCase() == 'penerimaan_kontrak'"
        class="margin-top"
      >
        <ul class="m-list-wrapper bordered">
          <li>
            <span class="m-list-title" for>Bank Account</span>
            <span class="m-list-desc">{{
              datasource.header_2 ? datasource.header_2.bank_account : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Project currency</span>
            <span class="m-list-desc">{{
              datasource.header_2 ? datasource.header_2.project_currency : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Exchange rate 1.00 USD to IDR</span>
            <span class="m-list-desc">{{
              datasource.header_2 ? datasource.header_2.exchange_rate : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>Project Value</span>
            <span class="m-list-desc">{{
              formatCurrency(
                datasource.header_2 ? datasource.header_2.currency : "IDR",
                datasource.header_2 ? datasource.header_2.project_value : 0
              )
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>ppn</span>
            <span class="m-list-desc">{{
              datasource.header_2 ? datasource.header_2.include_ppn : "-"
            }}</span>
          </li>
        </ul>
      </a-card>
      <a-card
        v-if="
          tab !== 'needprocess' && jns.toLowerCase() == 'penerimaan_kontrak'
        "
        class="margin-top"
      >
        <ul class="m-list-wrapper bordered">
          <li>
            <span class="m-list-title" for>Value AR</span>
            <span class="m-list-desc">{{
              datasource.header_3
                ? this.formatCurrency(
                    datasource.header_3.currency,
                    datasource.header_3.ar_value
                  )
                : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>work no / work name</span>
            <span class="m-list-desc">{{
              datasource.header_3 ? datasource.header_3.work_nm : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>invoice date</span>
            <span class="m-list-desc">{{
              datasource.header_3 ? moment(
                datasource.header_1 ? datasource.header_3.invoice_dt : null
              ).format(getDefaultDateFormat) : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>EFAKTUR NO</span>
            <span class="m-list-desc">{{
              datasource.header_3 ? datasource.header_1.efaktur_no : "-"
            }}</span>
          </li>
        </ul>
      </a-card>
      <a-collapse
        v-if="jns.toLowerCase() == 'penerimaan_kontrak'"
        class="margin-top"
        activeKey="3"
      >
        <a-collapse-panel key="3">
          <h4 slot="header" class="margin-remove">Detail product</h4>
          <a-table
            :columns="columns_dtl_product"
            :dataSource="datasource.header_4"
            :pagination="pagination"
            size="small"
            :rowKey="(record, index) => {return index;}"
            bordered
            :scroll="{ x: 950 }"
          >
            <!-- <span slot="value" slot-scope="value"> -->
              <span slot="termin_release_dtl" slot-scope="value">
                <h4>{{value.termin_release_dtl}}</h4>
                <span>{{formatCurrency(value.currency,value.termin_value)}}</span><br/>
                <span>{{value.termin_catatan}}</span>
              </span>
              <span slot="unit_price" slot-scope="value">
                <span>{{formatCurrency(value.currency,value.unit_price)}}</span>
              </span>
              <span slot="total_price" slot-scope="value">
                <span>{{formatCurrency(value.currency,value.total_price)}}</span>
              </span>
              <span slot="total_price" slot-scope="value">
                <span>{{formatCurrency(value.currency,value.total_price)}}</span>
              </span>
              <div slot="footer" v-if="datasource.header_5">
                <a-row :gutter="24">
                  <a-col :xs="{ span: 24 }" :lg="{ span: 4 }"><h5>TAX</h5></a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: 10 }"><h5>: {{ datasource.header_5.type_ppn_label }}</h5></a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                    <div style="text-align:right">
                      <a-button
                      size="small" icon="edit"
                      :type="datasource.header_5 && datasource.header_5.kode_setoran_pajak!=null ? 'primary' : 'danger'"
                      @click="handleShowTaxHeader"
                      :disabled="datasource.last_status != 'On Process'"
                      v-if="isTaxOfficer && datasource.header_5 && iftaxheaderdeposit(datasource.header_5.type_ppn)"
                      >Tax Deposit</a-button>
                    </div>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 4 }"><h5>VALUE</h5></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 10 }"><h5>: {{ formatCurrency(datasource.header_5.currency, datasource.header_5.value_tax) }}</h5></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                      <div style="text-align:right">
                        <a-button
                        size="small" icon="file"
                        v-if="datasource.header_5 && datasource.header_5.tax_document_file"
                        @click="handleviewFileHeader(datasource.header_5.tax_document_path)"
                        class="margin-top"
                        >
                          View File
                        </a-button>
                      </div>
                    </a-col>
                  </a-row>
              </div>
          </a-table>
        </a-collapse-panel>
      </a-collapse>
      <a-collapse
        v-if="jns.toLowerCase() == 'penerimaan_kontrak' && (datasource.dtl_tax && datasource.dtl_tax.length>0)"
        class="margin-top"
        activeKey="2"
      >
        <a-collapse-panel key="2">
          <h4 slot="header" class="margin-remove">List Details</h4>
          <a-table
            :columns="columns_dtl_tax"
            :dataSource="datasource.dtl_tax"
            :pagination="pagination"
            size="small"
            :rowKey="(record, index) => {return index;}"
            bordered
            :scroll="{ x: 500 }"
          >
              <span slot="type_tax" slot-scope="data">
                <span>{{ gettitletax(data.type_tax)}}</span>
              </span>
              <span slot="value" slot-scope="data">
                <span>{{formatCurrency(datasource.header_1.currency,data.value_tax)}}</span>
              </span>
              <span slot="tax_deposit" slot-scope="item">
                <div style="text-align: center;">
                  <a-button icon="edit" size="small" 
                    v-if="item.type_tax != 'bea_masuk' && item.type_tax != 'fee_lain_lain'"
                    :type="item.kode_setoran_pajak!=null && item.kode_setoran_pajak!=null ? 'primary' : 'danger'" 
                    style="margin-right:5px"
                    @click="handleShowTaxModal(item)"
                    :disabled="datasource.last_status!='On Process'"
                    >
                  </a-button>
                </div>
              </span>
          </a-table>
        </a-collapse-panel>
      </a-collapse>
      <!-- <a-card
        v-if="jns.toLowerCase() == 'penerimaan_kontrak'"
        class="margin-top"
      >
        <ul class="m-list-wrapper bordered">
          <li>
            <span class="m-list-title" for>ppn sktd</span>
            <span class="m-list-desc">{{
              datasource.header_5
                ? this.formatCurrency(
                    datasource.header_5.currency,
                    datasource.header_5.ppn_sktd
                  )
                : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>ppn dipungut</span>
            <span class="m-list-desc">
              <div class="m-display-flex flex-row space-between">
                {{
                datasource.header_5
                  ? this.formatCurrency(
                      datasource.header_5.currency,
                      datasource.header_5.ppn_dipungut
                    )
                  : "-"
                }}
                <a-button 
                  v-if="datasource.header_5 && datasource.header_5.type_ppn=='ppn_dipungut'"
                  @click="handleviewpphattachment(datasource.header_5)"
                  icon="eye">
                  View Attachment
                </a-button>
              </div>
              </span>
          </li>
          <li>
            <span class="m-list-title" for>ppn memungut</span>
            <span class="m-list-desc">
              <div class="m-display-flex flex-row space-between">
                {{
                  datasource.header_5
                    ? this.formatCurrency(
                        datasource.header_5.currency,
                        datasource.header_5.ppn_memungut
                      )
                    : "-"
                }}
                <a-button 
                  v-if="datasource.header_5 && datasource.header_5.type_ppn=='ppn_memungut'"
                  @click="handleviewpphattachment(datasource.header_5)"
                  icon="eye">
                  View Attachment
                </a-button>
              </div>
            </span>
          </li>
          <li>
            <span class="m-list-title" for>ppn migas</span>
            <span class="m-list-desc">
              <div class="m-display-flex flex-row space-between">
                {{
                datasource.header_5
                  ? this.formatCurrency(
                      datasource.header_5.currency,
                      datasource.header_5.ppn_migas
                    )
                  : "-"
                }}
                <a-button 
                  v-if="datasource.header_5 && datasource.header_5.type_ppn=='ppn_migas'"
                  @click="handleviewpphattachment(datasource.header_5)"
                  icon="eye">
                  View Attachment
                </a-button>
              </div>
            </span>
          </li>
          <li>
            <span class="m-list-title" for>pph 22-15 %</span>
            <span class="m-list-desc">
                {{
                  datasource.header_5
                    ? this.formatCurrency(
                        datasource.header_5.currency,
                        datasource.header_5.pph22_15
                      )
                    : "-"
                }}
            </span>
          </li>
          <li>
            <span class="m-list-title" for>pph 23</span>
            <span class="m-list-desc">{{
              datasource.header_5
                ? datasource.header_5.pph23 ? this.formatCurrency(
                    datasource.header_5.currency,
                    datasource.header_5.pph23
                  ) : '-'
                : "-"
            }}
            </span>
          </li>
          <li>
            <span class="m-list-title" for>Commision</span>
            <span class="m-list-desc">{{
              datasource.header_5
                ? this.formatCurrency(
                    datasource.header_5.currency,
                    datasource.header_5.komisi
                  )
                : "-"
            }}</span>
          </li>
          <li>
            <span class="m-list-title" for>fee lain-lain</span>
            <span class="m-list-desc">{{
              datasource.header_5
                ? this.formatCurrency(
                    datasource.header_5.currency,
                    datasource.header_5.fee_lain
                  )
                : "-"
            }}</span>
          </li>
          <!-- <li>
            <span class="m-list-title" for>taktis</span>
            <span class="m-list-desc">{{
              datasource.header_5
                ? this.formatCurrency(
                    datasource.header_5.currency,
                    datasource.header_5.taktis
                  )
                : "-"
            }}</span>
          </li> --
        </ul>
      </a-card> -->
      <a-card
        class="margin-top"
        :loading="loading.page"
        v-if="datasource.jenis=='Verifikator'"
      >
        <div slot="title">
          Manifest Actions
        </div>
        <a-form :form="form">
          <a-form-item label="Note">
            <a-textarea
              placeholder="Write the note here ... "
              :rows="4"
              v-decorator="['catatan']"
            />
          </a-form-item>
          <a-form-item label="Actions">
            <a-select
              showSearch
              v-decorator="['aksi', { rules: [{ required: true }] }]"
            >
              <a-select-option v-for="item in datasource.aksi" :key="item.aksi">{{
                item.aksi
              }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-button
              @click="handleAction"
              :loading="loading.loadingSave"
              block
              type="primary"
              html-type="submit"
              >Save</a-button
            >
          </a-form-item>
        </a-form>
      </a-card>
      <a-collapse
        v-if="getScreen && jns.toLowerCase() == 'piutang_lain_lain'"
        class="margin-top"
        activeKey="1"
      >
        <a-collapse-panel key="1">
          <h4 slot="header" class="margin-remove">
            Detail Account Receivement General
          </h4>
          <a-list
            itemLayout="vertical"
            :dataSource="datasource.header_2"
            :pagination="pagination"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <span slot="title">
                  <a @click="handleViewDoc(item)">{{
                    item.no_invoice ? item.no_invoice : "-"
                  }}</a></span
                >
                <div slot="description" class="margin-remove">
                  <span>{{
                    moment(item.date).format(getDefaultDateFormat)
                  }}</span>
                  <div>
                    <h4 class="margin-remove">
                      {{ formatCurrency(item.currency, item.value) }}
                    </h4>
                  </div>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
      <a-collapse
        v-if="!getScreen && jns.toLowerCase() == 'piutang_lain_lain'"
        class="margin-top"
        activeKey="1"
      >
        <a-collapse-panel key="1">
          <h4 slot="header" class="margin-remove">
            Detail Account Receivement General
          </h4>
          <a-table
            :columns="columns"
            :dataSource="datasource.header_2"
            :pagination="pagination"
            size="small"
            bordered
            :scroll="{ x: 950 }"
          >
            <span slot="value" slot-scope="value">
              <CurrencyJustified
                v-if="value.value"
                :currencyValue="value.currency"
                :valueNumber="Number(value.value)"
              />
              <div v-else style="text-align: center; width: 100%">-</div>
            </span>
            <span slot="dates" slot-scope="dates">{{
              moment(dates.date).format(getDefaultDateFormat)
            }}</span>
            <span slot="doc_transfer" slot-scope="doc_transfer">
              <a @click="handleViewDoc(doc_transfer)">{{
                doc_transfer.doc_transfer
              }}</a>
            </span>
          </a-table>
        </a-collapse-panel>
      </a-collapse>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card
        v-if="jns.toLowerCase() == 'penerimaan_kontrak'"
        :class="getScreen ? 'margin-top margin-bottom' : 'margin-bottom'"
      >
        <div slot="title">Evidence of Transfer</div>
        <div>
          <a-alert
            v-if="
              datasource.bukti_transfer == null ||
              datasource.bukti_transfer.length == 0
            "
            type="error"
            message="No evidence of transfer was uploaded"
            banner
          />
          <a-list
            itemLayout="horizontal"
            :dataSource="datasource.bukti_transfer"
            v-else
          >
            <Empty
              v-if="
                datasource.bukti_transfer !== null
                  ? datasource.bukti_transfer.length <= 0
                  : datasource.bukti_transfer
              "
            />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <div slot="title" class="m-display-flex space-between">
                  <div>
                    <h4 class="margin-remove">
                      {{ item.file_name }}
                    </h4>
                  </div>
                  <a-button
                    @click="handleViewTransfer(item)"
                    size="small"
                    type="default"
                    icon="eye"
                    >View</a-button
                  >
                </div>
                <Mis-Image
                  v-if="isExistsUrlFile($serviceUrl + item.path)"
                  class="m-image-icon"
                  slot="avatar"
                  :source="$serviceUrl + item.path"
                />
                <div slot="avatar" v-else>
                  <a-icon
                    :type="
                      load_icon(
                        item.path
                          ? item.path.substring(item.path.lastIndexOf('.') + 1)
                          : 'file'
                      )
                    "
                    style="font-size: 48px"
                  />
                </div>
                <p slot="description" class="margin-remove">
                  {{ item.user_tf }}
                </p>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
      </a-card>
      <a-collapse activeKey="1">
        <a-collapse-panel key="1">
          <div class="m-display-flex space-between align-middle" slot="header">
            <h4 class="margin-remove">Dokumen Pendukung</h4>
          </div>
          <a-list itemLayout="horizontal" :dataSource="datasource.header_6">
            <Empty
              v-if="
                datasource.header_6
                  ? datasource.header_6.length <= 0
                  : datasource.header_6
              "
            />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <div
                  slot="title"
                  class="m-display-flex space-between align-middle"
                >
                  <h4 class="m-list-dots margin-removes">
                    {{ item.nama_file }}
                  </h4>
                  <a-button
                    size="small"
                    type="default"
                    icon="cloud-download"
                    @click="handleDownload(item)"
                  ></a-button>
                </div>
                <p slot="description" :class="getScreen ? 'm-list-dots' : ''">
                  {{ item.deskripsi_doc }}
                </p>
                <img
                  class="m-image-icon"
                  slot="avatar"
                  src="@/assets/icon/pdf_ico.png"
                />
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
      <a-collapse class="margin-top" activeKey="1">
        <a-collapse-panel key="1">
          <div
            class="m-display-flex space-between align-middle"
            slot="header"
          >
            <h4 class="margin-remove">Status</h4>
            <div>
              <Status :status="datasource.last_status" />
              <a-button
                @click="historyToggle"
                type="default"
                size="small"
                class="margin-right-small"
              >
                <a-icon type="history" />
              </a-button>
            </div>
          </div>
          <a-timeline class="m-timeline">
            <a-timeline-item color="green">
              <div class="m-timeline-title">
                Creator -
                {{
                  datasource.header_1
                    ? datasource.header_1.tlc_create
                    : ""
                }}
              </div>
              <div class="m-timeline-body">
                <h4 class="margin-remove">
                  {{
                    moment(
                      datasource.header_1
                        ? datasource.header_1.create_dt
                        : null
                    ).format(getDateTimeFormat)
                  }}
                </h4>
                <span
                  class="m-text-small"
                  v-if="
                    datasource.data_header
                      ? datasource.data_header.catatan
                      : null
                  "
                  >{{ datasource.data_header.catatan }}</span
                >
                <span class="m-text-small" v-else>Tidak Ada Catatan</span>
              </div>
              <div class="m-timeline-footer">
                <a-tag color="green">Created</a-tag>
              </div>
            </a-timeline-item>
            <a-timeline-item
              v-for="(workflow,index) in datasource.status_app"
              :key="index"
            >
              <div class="m-timeline-title">
                {{ workflow.actor }}
                {{ workflow.tlc ? " - " + workflow.tlc : "" }}
              </div>
              <div class="m-timeline-body">
                <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                  {{
                    moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                  }}
                </h4>
                <span class="m-text-small" v-if="workflow.remark">{{
                  workflow.remark
                }}</span>
                <span class="m-text-small" v-else>Tidak Ada Catatan</span>
              </div>
              <div class="m-timeline-footer">
                <Status :status="workflow.status" />
              </div>
            </a-timeline-item>
          </a-timeline>
        </a-collapse-panel>
      </a-collapse>
      <a-collapse
        class="margin-top"
        activeKey="1"
        v-if="jns.toLowerCase() == 'penerimaan_kontrak'"
      >
        <a-collapse-panel key="1">
          <div class="m-display-flex space-between align-middle" slot="header">
            <h4 class="margin-remove">Related Document</h4>
          </div>
          <a-list itemLayout="horizontal" :dataSource="datasource.header_7">
            <Empty
              v-if="
                datasource.header_7
                  ? datasource.header_7.length <= 0
                  : datasource.header_7
              "
            />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <div
                  slot="title"
                  class="m-display-flex space-between align-middle"
                >
                  <a @click="handleDocument(item)"
                    >{{ item.header }} | {{ item.user_pembuat }}</a
                  >
                  <Status
                    :class="!getScreen ? 'margin-remove' : ''"
                    :status="item.status"
                  />
                </div>
                <div
                  slot="title"
                  class="m-display-flex space-between align-middle"
                  v-if="item.no_trans"
                >
                  <span>{{ item.no_trans }}</span>
                </div>
                <div slot="description">
                  <div class="m-width-full">
                    <a-tooltip
                      class="ant-tooltip-inner"
                      placement="top"
                      :title="
                        item.description
                          ? item.description
                          : 'Tidak ada deskripsi'
                      "
                    >
                      <span class="ant-description-ellipses">{{
                        item.description
                          ? item.description
                          : "Tidak ada deskripsi"
                      }}</span>
                    </a-tooltip>
                  </div>
                </div>
                <div slot="title" v-if="item.value">
                  <span class="m-timeline-title">{{
                    formatCurrency(item.currency, item.value)
                  }}</span>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
    </a-col>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="history" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="(history,index) in datasource.history" :key="index">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <TaxDepositEntry 
      :v-if="visibleTaxModal" 
      :visibleTaxModal="visibleTaxModal" 
      :getType_tax="getType_taxConditioned"
      :getListsetoranpajak="datapajak.getListsetoranpajak"
      :getListobjekpajak="datapajak.getListobjekpajak"
      :tax_type="datapajak.tax_type"
      :file_document_tax="datapajak.file_document_tax"
      :kode_setoran_pajak="datapajak.kode_setoran_pajak"
      :objek_pajak="datapajak.objek_pajak"
      :id_header="datapajak.id_header"
      :id_dtl="datapajak.id_dtl"
      :dpp_value="datapajak.dpp_value"
      :value="datapajak.value"
      :file="datapajak.fileList"
      :jenis_transaksi="datapajak.jenis_transaksi"
      :hideUploadDocTax="true"
      />
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import dueDateCalc from "@/mixins/dueDateCalc.js";
import Status from "@/components/Status.vue";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import TaxDepositEntry from "@/components/TaxDepositEntry.vue";
import _ from "lodash";
import axios from "axios";

export default {
  name: "manifest-ar",
  props: {
    jns: String,
    id: String,
    tab: String,
  },
  components: { Status, TaxDepositEntry, },
  data() {
    let type_tax_master = [
      {key:'fee_lain_lain',title:'Fee Lain-lain'},
      {key:'pph_22_15',title:'PPH 22-15 %'},
      {key:'pph_23',title:'PPH 23'},
      {key:'ppn_dipungut',title:'PPN Dipungut'},
      {key:'ppn_memungut',title:'PPN Memungut'},
      {key:'ppn_migas',title:'PPN MIGAS'},
      {key:'ppn_sktd',title:'PPN SKTD'},
      ];
    return {
      type_tax_master,
      datasource: {
        bukti_transfer: [],
      },
      dueDays: 0,
      pagination: {
        onChange: () => {},
        pageSize: 5,
        size: "small",
      },
      loading: {
        loadingPrint: false,
        loadingPrint2: false,
        loadingSave:false,
        loadingCancel: false,
        manifestkomisi:false,
        page: false,
      },
      status_cancel : false,
      status_edit : false,
      status_cetak : false,
      visibleHistory: false,
      visibleTaxModal: false,
      datapajak: {
        jenis_transaksi: "account_receivable",
        getListsetoranpajak:{},
        getListobjekpajak:{},
        tax_type:"",
        file_document_tax:null,
        kode_setoran_pajak:"",
        objek_pajak:"",
        id_header:"",
        id_dtl:"",
      }
    };
  },
  mixins: [dueDateCalc, HandleRoute, CurrencyFormat, GlobalMethod],
  mounted() {
    this.fetch();
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    Event.$on("handleCancel", this.canceltrans);
    Event.$on("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$on("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
    Event.$off("handleCancel", this.canceltrans);
    Event.$off("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$off("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getDefaultDateFormat",
      "getAuth",
      "getDateTimeFormat",
      "getType_tax",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        // {
        //   title: "No",
        //   dataIndex: "no",
        //   key: "no",
        //   width: 75,
        //   sorter: (a, b) => a.no - b.no,
        // },
        {
          title: "Date",
          width: 100,
          key: "date",
          scopedSlots: { customRender: "dates" },
          sorter: (a, b) =>
            new Date(
              moment(a.date, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.date, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "No Invoice",
          dataIndex: "no_invoice",
          key: "no_invoice",
          width: 300,
          sorter: (a, b) => a.no_invoice.length - b.no_invoice.length,
        },

        {
          title: "value",
          key: "value",
          sorter: (a, b) => a.value.length - b.value.length,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Doc. Transfer",
          key: "doc_transfer",
          sorter: (a, b) => a.doc_transfer.length - b.doc_transfer.length,
          scopedSlots: { customRender: "doc_transfer" },
        },
        {
          title: "TLC Create",
          dataIndex: "tlc_create",
          key: "tlc_create",
          align: "center",
          sorter: (a, b) => a.tlc_create.length - b.tlc_create.length,
        },
      ];
      return kolom;
    },
    columns_dtl_product(){
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        // {
        //   title: "No",
        //   dataIndex: "no",
        //   key: "no",
        //   width: 75,
        //   sorter: (a, b) => a.no - b.no,
        // },
        {
          title: "Product/Work",
          dataIndex: "product_nm",
          key: "product_nm",
          sorter: (a, b) => a.product_nm - b.product_nm,
        },

        {
          title: "Termin Detail",
          key: "termin_release_dtl",
          sorter: (a, b) => a.termin_release_dtl - b.termin_release_dtl,
          scopedSlots: { customRender: "termin_release_dtl" },
        },
        // {
        //   title: "Unit",
        //   key: "unit",
        //   dataIndex: "unit",
        //   sorter: (a, b) => a.unit - b.unit,
        // },
        {
          title: "Note",
          dataIndex: "note",
          key: "note",
          sorter: (a, b) => a.note - b.note,
        },
        {
          title: "Amount",
          key: "unit_price",
          sorter: (a, b) => a.unit_price - b.unit_price,
          scopedSlots: { customRender: "unit_price" },
        },
      ];
      return kolom;
    },
    columns_dtl_tax(){
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 75,
          align:"right",
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Type Tax",
          key: "type_tax",
          scopedSlots: { customRender: "type_tax" },
          sorter: (a, b) => a.type_tax - b.type_tax,
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "item_name",
          sorter: (a, b) => a.item_name - b.item_name,
        },
        {
          title: "Value",
          key: "value",
          align:"right",
          sorter: (a, b) => a.value - b.value,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Tax Deposit",
          key: "tax_deposit",
          width: "100px",
          fixed: "right",
          scopedSlots: { customRender: "tax_deposit" },
        },
      ];
      return this.isTaxOfficer ? kolom : _.filter(kolom,(item)=>item.key!='tax_deposit');
    },
    getType_taxConditioned() {
      let a = this.getType_tax;
      a.push({ text: 'PPN', value: 'ppn' });
      a.push({ text: 'PPH 23', value: 'pph_23' });
      a.push({ text: 'Fee Lain-lain', value: 'fee_lain_lain' });
      return a;
    },
    isTaxOfficer() {
      return (_.filter(this.getAuth.nama_bidang,(item)=> item && item.toLowerCase()=="tax officer")).length>0;
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    moment,
    fetch() {
      this.loading.page = true;
      this.$store
        .dispatch("getManifestAR", {
          id: this.id,
          tab: this.tab,
          jenis: this.jns,
          tlc: this.getAuth.username,
        })
        .then(
          (res) => {
            this.datasource.header_1 = res.header_1[0];
            if(res.status_cancel == "0"){
              this.status_cancel = true;
            }
            if(res.status_edit == "0"){
              this.status_edit = true;
            }
            if(res.status_cetak == "0"){
              this.status_edit = true;
            }
            if (this.jns.toLowerCase() == "penerimaan_kontrak") {
              this.datasource.header_2 = res.header_2[0];
              this.datasource.header_3 = res.header_3[0];
              this.datasource.header_4 = res.header_4;
              this.datasource.header_5 = res.header_5[0];
              this.datasource.header_7 = res.header_7;
              this.datasource.status_app = res.status_app;
              this.datasource.history = res.notifikasi;
              this.datasource.last_status = res.status_besar;
              this.datasource.dtl_tax = res.dtl_tax;
              _.forEach(this.datasource.dtl_tax, (data, index) => {
                this.datasource.dtl_tax[index].no = index+1;
              });
            } else {
              this.datasource.header_2 = res.header_2;
              _.forEach(this.datasource.header_2, (data, index) => {
                this.datasource.header_2[index].key = data.id_ar_general_dtl;
              });
              this.datasource.header_7 = [];
            }
            this.datasource.header_6 = res.header_6;

            this.datasource.bukti_transfer = res.bukti_transfer;
            this.dueDays = this.dateCalculation(
              this.datasource.header_1.due_date
            );

            this.datasource.iskomisi = res.komisi;

            this.datasource.aksi = res.aksi;
            this.datasource.jenis = res.jenis;
            this.datasource.setoran_pajak = res.setoran_pajak;
            this.datasource.objek_pajak = res.objek_pajak;

            this.loading.page = false;
          },
          (error) => {
            let responses = Object.assign({}, error);
            if (responses.response.data) {
              this.displayMessageValue(
                "error-other",
                responses.response.data.message
              );
            } else {
              this.displayMessageValue("error-other", responses.response);
            }
            this.loading.page = false;
          }
        );
    },
    handleDocument(item) {
      const data = {
        rest_api: item.rest_api.toLowerCase(),
        id_manifest: item.id,
        tlc: this.getAuth.username,
        user_pembuat: item.user_pembuat,
      };
      this.handleView(data, null);
    },
    handleViewDoc(item) {
      window.open(this.$serviceUrl + item.doc_path, "_blank");
    },
    handleViewTransfer(item) {
      window.open(this.$serviceUrl + item.path, "_blank");
    },
    handleDownload(item) {
      //console.log(item);
      window.open(this.$serviceUrl + item.path, "_blank");
    },
    handleviewFileHeader(item) {
      //console.log(item);
      window.open(this.$serviceUrl + item, "_blank");
    },
    handlePrint(type) {
      if (type == '2') {
        this.loading.loadingPrint2 = true;
      } else {
        this.loading.loadingPrint = true;
      }
      axios({
        method: "get",
        url: this.$serviceUrl + "account_receivable/cetak_AR",
        params: {
          id: this.id,
          show_dtl: type == '1' ? true : false,
        },
        responseType: "blob",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (type == '2') {
            this.loading.loadingPrint2 = false;
          } else {
            this.loading.loadingPrint = false;
          }
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        })
        .catch((err) => {
          if (err.response && err.response.status === 404) {
            this.displayMessage("404");
          } else if (err.response) {
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
          }
          if (type == '2') {
            this.loading.loadingPrint2 = false;
          } else {
            this.loading.loadingPrint = false;
          }
          this.$router.go(-1);
        });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.loading.loadingCancel = true;
      this.$store
        .dispatch("releaseAR", {
          auth: this.getAuth,
          id: this.id,
          jenis_transaksi: this.jns,
        })
        .then((response) => {
          this.loading.loadingCancel = false;
          this.displayMessageValue("success-other", response.message);
          this.$router.push({ name: "account-receive-index" });
        })
        .catch((error) => {
          console.log();
          this.loading.loadingCancel = false;
          let responses = Object.assign({}, error);
          console.log(responses);
          if (responses.data) {
            this.displayMessageValue("error-other", responses.data.message);
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
        });
    },
    handleEdit() {
      this.$router.push({
        name: "editNgeneral-account-receive",
        params: { id: this.id },
      });
    },
    handlePrintKomisi() {
      //console.log(item);
      this.loading.manifestkomisi = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "account_receivable/cetak_ar_komisi",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
            this.loading.manifestkomisi = false;
          window.open(url, "_blank");
        })
        .catch((err) => {
          this.loading.manifestkomisi = false;
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.$router.go(-1);
        });
    },
    handleviewpphattachment(item){
      window.open(this.$serviceUrl + item.path_upload_document_tax, "_blank");
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }
        
        if (values.aksi == "Verified"
          && this.iftaxheaderdeposit(this.datasource.header_5.type_ppn)
          && this.datasource.header_5.kode_setoran_pajak == null) {
          this.displayMessageValue("error-other", "Value tax Deposit on Detail Product Can't be empty!");
          return;
        }

        let entry = _.filter(this.datasource.dtl_tax, (item) => item.type_tax != 'bea_masuk'
          && item.type_tax != 'fee_lain_lain' && item.kode_setoran_pajak == null);
          console.log(entry)
        if (values.aksi == "Verified" && entry.length > 0) {
          this.displayMessageValue("error-other", "Value tax Deposit on List Details Can't be empty!");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("status", values.aksi);
        formData.append("remark", values.catatan ? values.catatan : "");

        this.loading.loadingSave = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "account_receivable/approval",
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.loading.loadingSave = false;
            this.displayMessage("success");
            this.$router.go(0);
          })
          .catch((err) => {
            this.loading.loadingSave = false;
            let responses = Object.assign({}, err);
            if (responses.response.data) {
              this.displayMessageValue("error-other", responses.response.data.message);
            } else {
              this.displayMessageValue("error", responses.response);
            }
          });
      });
    },
    historyToggle(e) {
      this.visibleHistory = !this.visibleHistory;
      e.stopPropagation();
    },
    gettitletax(val){
      let res = _.filter(this.getType_taxConditioned,(el)=>el.value==val);
      return res.length>0 ? res[0].text : val;
    },
    handleShowTaxHeader() {
      let item = {
        type_tax: "ppn",
        kode_setoran_pajak: this.datasource.header_5.kode_setoran_pajak,
        kode_objek_pajak: this.datasource.header_5.kode_objek_pajak,
        id_hdr: this.id,
        id_dtl: this.id,
        dpp_value: this.datasource.header_5.dpp_value,
        tax_value: this.datasource.header_5.value_tax,
        file_doc_tax: this.datasource.header_5.tax_document_name,
        document_file: this.datasource.header_5.file_upload_document_tax,
        document_path: this.datasource.header_5.tax_document_path,
        isheader: true
      }
      this.handleShowTaxModal(item);
    },
    async handleShowTaxModal(item) {
      this.datapajak.tax_type=item.type_tax;
      this.datapajak.kode_setoran_pajak=item.kode_setoran_pajak;
      this.datapajak.objek_pajak=item.kode_objek_pajak;
      this.datapajak.id_header=item.id_hdr;
      this.datapajak.id_dtl=item.id_dtl;
      this.datapajak.dpp_value=item.dpp_value;
      this.datapajak.value = item.tax_value;
      this.datapajak.jenis_transaksi = item.isheader ? "account_receivable_sales_contract" : "account_receivable";

      let filterTypeTax = "";
      if ("pph_22_15" == item.type_tax) {
        filterTypeTax = 'pph_22';
      } else if("commision" == item.type_tax){
        filterTypeTax = 'pph_21';
      } else {
        filterTypeTax = item.type_tax;
      }
      this.datapajak.getListsetoranpajak = _.filter(this.datasource.setoran_pajak,(obj)=> obj.id_type_tax == filterTypeTax);
      this.datapajak.getListobjekpajak = _.filter(this.datasource.objek_pajak,(obj)=> obj.id_type_tax == filterTypeTax);

      if (item.file_doc_tax!=null && item.file_doc_tax!="No File Uploaded"){
        let typefile = this.fileTypeFromUrl(item.file_doc_tax);
        let file = this.dataURLtoFile(typefile+item.document_file, item.file_doc_tax);
        file.uid= 'vc-upload-1-1';
        file.status= 'done';
        file.url= this.$serviceUrl+item.document_path;
        this.datapajak['fileList']=[];
        this.datapajak.fileList.push(file);
      }
      this.visibleTaxModal = true;
    },
    taxDepositEntryCancel(){
      this.visibleTaxModal = false;
    },
    taxDepositEntryUpdate(val) {
      if (val.jenis_transaksi == "account_receivable") {
        let index1 = _.findIndex(this.datasource.dtl_tax, { id_dtl: val.id_dtl });
        this.datasource.dtl_tax[index1].document_file = val.file_document_tax;
        this.datasource.dtl_tax[index1].tax_document = val.document_tax;
        this.datasource.dtl_tax[index1].document_path = val.document_path;
        this.datasource.dtl_tax[index1].tax_value = val.tax_value;
        this.datasource.dtl_tax[index1].kode_objek_pajak = val.objek_pajak;
        this.datasource.dtl_tax[index1].kode_setoran_pajak = val.kode_setoran_pajak;
        this.datasource.dtl_tax[index1].dpp_value = val.dpp_value;
      } else {
        this.datasource.header_5.file_upload_document_tax = val.file_document_tax;
        this.datasource.header_5.tax_document_name = val.document_tax;
        this.datasource.header_5.tax_document_path = val.document_path;
        this.datasource.header_5.tax_value = val.tax_value;
        this.datasource.header_5.value_tax = val.tax_value;
        this.datasource.header_5.kode_objek_pajak = val.objek_pajak;
        this.datasource.header_5.kode_setoran_pajak = val.kode_setoran_pajak;
        this.datasource.header_5.dpp_value = val.dpp_value;
      }
    },
    iftaxheaderdeposit(val) {
      let result = true;
      if (val == "null" || val == "ppn_sktd") {
        result = false;
      }
      return result;
    }
  },
};
</script>

<style lang="less">
.ant-table-thead > tr > th.ant-table-column-has-actions {
  text-align: center!important;
}
.ant-table-small.ant-table-bordered .ant-table-thead > tr > th.ant-table-row-cell-last, .ant-table-small.ant-table-bordered .ant-table-tbody > tr > td:last-child {
  text-align: center;
}
</style>
